export default __webpack_public_path__ + "static/media/buscando.2307514f.svg";